// import { Editor } from '@tiptap/react';
// import { create } from 'zustand';

// interface UseEditorStoreInterface {
//   editor: Editor | null;
//   editorVersion: number;
//   setEditor: (editor: Editor | null) => void;
// }

// export const useEditorStore = create<UseEditorStoreInterface>()((set, get) => {
//   return {
//     editor: null,
//     editorVersion: 0,

//     setEditor: (editor) => {
//       // Clean up previous editor listeners if any
//       const currentEditor = get().editor;
//       if (currentEditor) {
//         // Remove existing listeners to prevent memory leaks
//         currentEditor.off('selectionUpdate');
//         currentEditor.off('update');
//         currentEditor.off('transaction');
//       }

//       set({ editor });

//       // Set up listeners to increment version when editor state changes
//       if (editor) {
//         const updateVersion = () => {
//           set((state) => ({ editorVersion: state.editorVersion + 1 }));
//         };

//         editor.on('selectionUpdate', updateVersion);
//         editor.on('update', updateVersion);
//         editor.on('transaction', updateVersion);
//       }
//     },
//   };
// });

import { Editor } from '@tiptap/react';
import { create } from 'zustand';

interface UseEditorStoreInterface {
  editor: Editor | null;
  setEditor: (editor: Editor | null) => void;
  activeAttributes: {
    color?: string;
    bold?: boolean;
    italic?: boolean;
    textAlign?: string;
    fontSize?: number;
    letterSpacing?: number;
    lineHeight?: number;
  };
  setActiveAttributes: (
    attrs: Partial<UseEditorStoreInterface['activeAttributes']>
  ) => void;
}

export const useEditorStore = create<UseEditorStoreInterface>()((set, get) => {
  return {
    editor: null,
    setEditor: (editor) => set({ editor }),
    activeAttributes: {},
    setActiveAttributes: (attrs) =>
      set((state) => ({
        activeAttributes: {
          ...state.activeAttributes,
          ...attrs,
        },
      })),
  };
});
